import React from "react";
import { AvatarChat } from "../avatar-chat";
import classNames from "classnames";

export type ChatUserPanelProps = {
  pictureUrl?: string;
  fullName?: string;
  text?: string;
  time?: string;
  onClick?: () => void;
  active?: boolean;
};

export function ChatUserPanel({ fullName, time, text, onClick, active }: ChatUserPanelProps) {
  const [firstName, lastName] = fullName?.split(" ") || [];
  const firstLetter = firstName.length > 0 ? firstName[0] : "N/A";
  const lastLetter = lastName && lastName.length > 0 ? lastName[0] : "";

  return (
    <div
      className={classNames([
        "px-5",
        "py-3.5",
        "flex",
        "font-sans-serif",
        "w-full",
        active && "bg-gradient-light",
        onClick && "cursor-pointer",
        onClick && "hover:bg-gradient-light",
      ])}
      onClick={onClick}
    >
      <div className=''>
        <AvatarChat width={50} shortName={`${firstLetter}${lastLetter}`} />
      </div>
      <div className='ml-2.5 w-full flex flex-col justify-center'>
        <div className='flex justify-between items-center'>
          <div className='text-sm font-semibold'>{`${firstName}${
            lastName ? ` ${lastName}` : ""
          }`}</div>
          {time && <div className='text-xs text-mid-neutral-1'>4:30PM</div>}
        </div>
        {text && <div className='text-xs text-mid-neutral-1'>{text}</div>}
      </div>
    </div>
  );
}
